import React from "react";

import { authHeader } from "../_helpers";
import Modal from 'react-bootstrap/Modal'
import moment from "moment"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ReactExport from "react-data-export";
import SideMenu from './SideMenu';
import Header from './Header';



class UploadStudent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            uploadStudents: false,
            allStudents: [],
            selectedStudentFile: null,
            showModal: false,
            name: '',
            studentClass: '',
            dob: '',
            rollNo: '',
            registrationNo: '',
            email: '',
            phone: '',
            studentId: ''

        }
        this.onFileUploadStudent = this.onFileUploadStudent.bind(this);
        this.onFileChangeStudent = this.onFileChangeStudent.bind(this);
    }

    componentDidMount() {
        this.fetchAllStudents();
    }

    fetchAllStudents = () => {
        let user = JSON.parse(localStorage.getItem("user"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + user.data.accessToken
        };
        let url = `http://15.206.132.121:3002/api/getAllStudents`;
        fetch(url, { headers })
            .then(response => response.json())
            .then(data => {
                if (!data.success) {
                    throw data.message;
                }
                this.setState({ allStudents: data.data });
            })
            .catch(err => {
                toast.error("Error! Please try again", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
    };


    onFileChangeStudent(e) {
        this.setState({ selectedStudentFile: e.target.files[0] });
    }

    onFileChangeResult(e) {
        this.setState({ selectedResultFile: e.target.files[0] });
    }

    onFileUploadStudent = event => {
        event.preventDefault();
        if (this.state.selectedStudentFile) {
            let file = this.state.selectedStudentFile;
            let filename = this.state.selectedStudentFile.name;
            const formData = new FormData();
            formData.append("file", file);
            formData.append("filename", filename);
            const requestOptions = {
                method: "POST",
                headers: authHeader(),
                body: formData
            };

            let url = "http://15.206.132.121:3002/api/studentData";
            return fetch(url, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (!data.success) {
                        toast.error(data.message, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined
                        });
                    } else {
                        toast.success("File uploaded successfully", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined
                        });
                    }
                })
                .catch(err =>
                    toast.error(err, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined
                    })
                );
        } else {
            toast.error("Please choose file to upload", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        }
    };

    toggleStudent = () => {
        this.setState({
            uploadStudents: !this.state.uploadStudents
        });
    };

    editStudentModal = (id) => {
        this.setState({
            showModal: !this.state.showModal
        }, () => this.setStudentForm(id))
    }

    setStudentForm = (id) => {
        let student = {}
        for (let i = 0; i < this.state.allStudents.length; i++) {
            if (this.state.allStudents[i].StudentID === id) {
                student = this.state.allStudents[i];
            }
        }

        this.setState({
            name: student.Name,
            studentClass: student.Class,
            email: student.Email,
            dob: moment(student.DateOfBirth, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            rollNo: student.RollNumber,
            registrationNo: student.RegistrationNumber,
            phone: student.PhoneNumber,
            studentId: id
        })
    }

    onChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    submitStudentEditing = (e) => {
        e.preventDefault();

        // get our form data out of state
        const {
            name, email, studentClass, rollNo, registrationNo, dob, phone, studentId
        } = this.state;
        let user = JSON.parse(localStorage.getItem("user"));
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + user.data.accessToken
            },
            body: JSON.stringify({
                name,
                email,
                rollNumber: rollNo,
                registrationNumber: registrationNo,
                dateOfBirth: dob,
                class: studentClass,
                phoneNumber: phone
            })
        };
        let url = `http://15.206.132.121:3002/api/updateStudent?Id=${studentId}`;
        return fetch(url, requestOptions)
            .then(response => response.json())
            .then(res => {
                if (!res.success) {
                    throw res.message;
                }
                this.setState({
                    showModal: false
                })
                this.fetchAllStudents();
                toast.success("Student updated successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });

            })
            .catch(err =>
                toast.error("Student Updation Failed", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                })
            );
    }


    render() {
        const { showModal, name, email, studentClass, rollNo, registrationNo, dob, phone } = this.state;
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        let user = JSON.parse(localStorage.getItem("user"));
        return (
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <section id="container">
                    <Header />
                    <SideMenu />

                    <section id="main-content">
                        <section className="wrapper">
                            <div>
                                <button
                                    className="btn btn-primary mt-5"
                                    onClick={this.toggleStudent}
                                >
                                    {this.state.uploadStudents ? "Show Students" : "Upload Students"}
                                </button>
                            </div>
                            <div className={`input-group file-upload-group container`} >
                                <form className={this.state.uploadStudents ? "collapse in" : "collapse"}>
                                    <span style={{ display: "flex" }} className={`ml-3`}>
                                        <input
                                            type="file"
                                            id="myfile"
                                            name="myfile"
                                            onChange={this.onFileChangeStudent}
                                        />
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.onFileUploadStudent}
                                        >
                                            Upload
                                    </button>
                                    &nbsp;
                                     <ExcelFile
                                            element={
                                                <button className="btn btn-primary">
                                                    Download Sample Excel
                                            </button>
                                            }
                                        >
                                            <ExcelSheet data={[]} name="Sample Student Excel">
                                                <ExcelColumn label="Name" value="name" />
                                                <ExcelColumn label="Email" value="email" />
                                                <ExcelColumn label="PhoneNo" value="phoneno" />
                                                <ExcelColumn label="RollNo" value="rollno" />
                                                <ExcelColumn
                                                    label="RegistrationNo"
                                                    value="registrationno"
                                                />
                                                <ExcelColumn label="DOB" value="dob" />
                                                <ExcelColumn label="Class" value="Class" />
                                            </ExcelSheet>
                                        </ExcelFile>
                                    </span>
                                </form>

                            </div>
                            <div className={`scroll-fit uploadStudent ${this.state.uploadStudents ? "collapse" : "collapse in"}`}>
                                <Modal
                                    show={showModal}
                                    size="lg"
                                    onHide={() => this.editStudentModal()}
                                    style={{ opacity: "1", marginTop: "8%" }}
                                    backdrop="static"
                                    aria-labelledby="example-modal-sizes-title-lg"
                                >
                                    <Modal.Header closeButton style={{ marginTop: '18%' }}>
                                        <Modal.Title id="example-modal-sizes-title-lg">
                                            Edit Student
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <form

                                            onSubmit={this.submitStudentEditing}
                                        >
                                            <div className="contact">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div
                                                            className="contact-form"
                                                            style={{
                                                                padding: "4%"
                                                            }}
                                                        >
                                                            <div className="form-group">
                                                                <label
                                                                    className="control-label col-sm-3"
                                                                    htmlFor="name"
                                                                >
                                                                    Name:
                                                            </label>
                                                                <div className="col-sm-9">
                                                                    <input
                                                                        type="text"
                                                                        name="name"
                                                                        value={name}
                                                                        onChange={this.onChange}
                                                                        className="form-control"
                                                                        placeholder="Enter Name"
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label
                                                                    className="control-label col-sm-3"
                                                                    htmlFor="dob"
                                                                >
                                                                    Date of Birth
                                                            </label>
                                                                <div className="col-sm-9">
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        name="dob"
                                                                        value={dob}
                                                                        onChange={this.onChange}
                                                                        placeholder="Enter Date of Birth"
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label
                                                                    className="control-label col-sm-3"
                                                                    htmlFor="rollNo"
                                                                >
                                                                    Roll No
                                                            </label>
                                                                <div className="col-sm-9">
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name="rollNo"
                                                                        value={rollNo}
                                                                        onChange={this.onChange}
                                                                        placeholder="Enter Roll Number"

                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label
                                                                    className="control-label col-sm-3"
                                                                    htmlFor="registrationNo"
                                                                >
                                                                    Registration No
                                                            </label>
                                                                <div className="col-sm-9">
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name="registrationNo"
                                                                        value={registrationNo}
                                                                        onChange={this.onChange}
                                                                        placeholder="Enter Registration Number"

                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label
                                                                    className="control-label col-sm-3"
                                                                    htmlFor="email"
                                                                >
                                                                    Email
                                                            </label>
                                                                <div className="col-sm-9">
                                                                    <input
                                                                        className="form-control"
                                                                        type="email"
                                                                        name="email"
                                                                        value={email}
                                                                        onChange={this.onChange}
                                                                        placeholder="Enter Email"
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label
                                                                    className="control-label col-sm-3"
                                                                    htmlFor="phone"
                                                                >
                                                                    Phone
                                                            </label>
                                                                <div className="col-sm-9">
                                                                    <input
                                                                        className="form-control"
                                                                        type="phone"
                                                                        name="phone"
                                                                        value={phone}
                                                                        onChange={this.onChange}
                                                                        placeholder="Enter Email"
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label
                                                                    className="control-label col-sm-3"
                                                                    htmlFor="studentClass"
                                                                >
                                                                    Class
                                                            </label>
                                                                <div className="col-sm-9">
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name="studentClass"
                                                                        value={studentClass}
                                                                        onChange={this.onChange}
                                                                        placeholder="Enter Registration Number"
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>


                                                            <div className="form-group">
                                                                <div className="col-sm-12">
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-primary"
                                                                        style={{ float: "right" }}
                                                                    >
                                                                        Submit
                            </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form></Modal.Body>
                                </Modal>
                                <table className={`table table-hover general-table `}>
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th> Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Class</th>
                                            <th>Roll No</th>
                                            <th>Reg. No</th>
                                            <th>DOB</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.allStudents.map((student, index) => {
                                            return (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{student.Name}</td>
                                                    <td>{student.Email}</td>
                                                    <td>{student.PhoneNumber}</td>
                                                    <td>{student.Class}</td>
                                                    <td>{student.RollNumber}</td>
                                                    <td>{student.RegistrationNumber}</td>
                                                    <td>{student.DateOfBirth}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => this.editStudentModal(student.StudentID)}
                                                        >
                                                            Edit
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </section>
                </section>
            </div >
        );
    }
}

export default UploadStudent;
